<p>outsource-reports works!</p>
